import { render, staticRenderFns } from "./TempItem.vue?vue&type=template&id=80fb2a1e&scoped=true"
import script from "./TempItem.vue?vue&type=script&lang=js"
export * from "./TempItem.vue?vue&type=script&lang=js"
import style0 from "./TempItem.vue?vue&type=style&index=0&id=80fb2a1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fb2a1e",
  null
  
)

export default component.exports